<template>
  <div class="launcher" v-if="app!=null && app.data !=null">
    <div class="rules" id="rules-content">
    <!-- <div @click="app.closeAbout()" id="boule">=</div> -->
      <div @click="app.closeRules()" id="close-rules"><img src="arrows/white-cross.png"></div>
      
        <div id="rules-selector">      
            <h2>Règles du jeu</h2>
            <p>Il vous faudra <span>VOIR</span> et pas seulement regarder !</p>
            <h2>POUR UNE VISITE SOUS FORME DE JEU:</h2>
            <p>-Un détail d'un tableau, d'un objet...<br>
            vous est donné</p>
            <p>-Trouvez l'oeuvre dans les salles <span>(indice)</span></p>
            <p>-Répondez à la question posée (pour les niveaux Découverte et Expert: la lecture des cartels explicatifs peut aider; pour le niveau Junior: ouvrez les yeux!)<br></p>
            <p><span>Après un parcours de 20 questions :</span></p>
            <h2>BONUS<br>
            RIEN QUE POUR VOS YEUX:</h2>
            <p>Découvrez un tableau, un objet...<br>
            que vous ne verrez jamais car elle est conservée dans les réserves<br></p>
            <p><span>Ouvrez l'oeil et... Bonne visite</span></p>
        </div>
        
      </div>

  </div>
</template>

<script>

export default {
  name: 'SettingsVue',
  props: {
    app:Object
  },
  components :{
  }
}
</script>


